import { getTheme } from '../theme/theme_context';
export const THEME_SCOPE_PROP = '__smthTheme';
export function resolveScopedTheme(props) {
    const scopedTheme = props[THEME_SCOPE_PROP];
    return isTheme(scopedTheme) ? scopedTheme : getTheme();
}
export function stripInternalRuntimeProps(props) {
    if (!(THEME_SCOPE_PROP in props)) {
        return props;
    }
    const { [THEME_SCOPE_PROP]: _scopedTheme, ...publicProps } = props;
    return publicProps;
}
function isTheme(value) {
    return typeof value === 'object'
        && value !== null
        && 'breakpoints' in value
        && 'colors' in value;
}
//# sourceMappingURL=internal-props.js.map